function selectInit() {
    var entered = false;
    var dropDownTether = '';

    document.querySelector('.select-wrapper.select-2 input').addEventListener('focus', function () {
        var input = document.querySelector('.select-2 .select-dropdown');
        var inputWidth = window.getComputedStyle(input).getPropertyValue('width');
        var dropDown = document.querySelector('.dropdown-content.select-2');
        dropDown.classList.add('active');
        dropDown.style.width = inputWidth;
        dropDownTether = new Tether({
            element: '.dropdown-content.select-2',
            target: '.select-wrapper.select-2 input',
            attachment: 'top left',
            targetAttachment: 'top left'
        });
    })

    document.querySelector('.select-wrapper.select-2 input').addEventListener('blur', function () {
        if (!entered) {
            document.querySelector('.dropdown-content.select-2').classList.remove('active');
            document.querySelector('.select-wrapper.select-2').appendChild(document.querySelector('.dropdown-content.select-2'));
        }
    })

    var li = document.querySelectorAll('.dropdown-content.select-2 li');

    for (var i = 0; i < li.length; i++) {
        li[i].addEventListener('click', function () {
            var currentSelected = document.querySelector('.dropdown-content.select-2 li.selected');
            if (currentSelected) {
                currentSelected.classList.remove('selected');
            }
            this.classList.add('selected');
            document.querySelector('.select-wrapper.select-2 input').value = this.innerText;
            entered = false;
            document.querySelector('.dropdown-content.select-2').classList.remove('active');
            document.querySelector('.select-wrapper.select-2').appendChild(document.querySelector('.dropdown-content.select-2'));
        })
    }

    document.querySelector('.dropdown-content.select-2').addEventListener('mouseenter', function () {
        entered = true;
    })

    document.querySelector('.dropdown-content.select-2').addEventListener('mouseleave', function () {
        entered = false;
    })
}


$(function () {
    //selectInit();
});
